var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSort1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 2C0.5 1.17157 1.17157 0.5 2 0.5H20C20.8284 0.5 21.5 1.17157 21.5 2V20C21.5 20.8284 20.8284 21.5 20 21.5H2C1.17157 21.5 0.5 20.8284 0.5 20V2Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.0623 5.9375L7.06224 14.7035L7.78955 13.9773L8.58505 14.7727L6.4998 16.858L4.41455 14.7727L5.21005 13.9773L5.93724 14.7035L5.9373 5.9375H7.0623ZM12.1248 14.375V15.5H9.3123V14.375H12.1248ZM13.8123 11.5625V12.6875H9.3123V11.5625H13.8123ZM15.4998 8.75V9.875H9.3123V8.75H15.4998ZM17.1873 5.9375V7.0625H9.3123V5.9375H17.1873Z",
    fill: "#2196F3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 2C0.5 1.17157 1.17157 0.5 2 0.5H20C20.8284 0.5 21.5 1.17157 21.5 2V20C21.5 20.8284 20.8284 21.5 20 21.5H2C1.17157 21.5 0.5 20.8284 0.5 20V2Z",
    stroke: "#D1D6DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSort1);
export default __webpack_public_path__ + "static/media/sort1.f96f559c472fa5bbb75883d1bf00444c.svg";
export { ForwardRef as ReactComponent };